import React from 'react'
import { Verified } from '@ticketswap/comets'
import styled from '@emotion/styled'
import { color, device } from '@ticketswap/solar'
import { useViewer } from '~/components/ViewerContext'

const Circle = styled.div`
  background-color: ${color.stardust};
  width: 22px;
  height: 22px;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  bottom: -4px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }
`

const VerifiedBadge = styled.span``

const ListingAvatarBadge = () => {
  const { deviceInfo } = useViewer()
  const { isMobile } = deviceInfo

  return (
    <Circle>
      <VerifiedBadge>
        <Verified size={isMobile ? 16 : 18} />
      </VerifiedBadge>
    </Circle>
  )
}

export default ListingAvatarBadge
